<h2 *ngIf="dataLanding.schema.title.properties.visible" [class]="dataLanding.schema.title.properties.fontSize">{{dataLanding.schema.title.properties.data}}</h2>